import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AsyncListState, BasicFilters } from 'src/app/core/services/async-list.service';

@Component({
  selector: 'sky-table[state]',
  template: `
    <div *ngIf="state.fetching" class="flex justify-center py-6">
      <sky-spinner size="2xl"></sky-spinner>
    </div>
    <ng-container *ngIf="state.ready">
      <ng-container *ngIf="!isMobileView; else mobileTemplate">
        <table class="w-full">
          <ng-container *ngIf="!state.model.length"> </ng-container>
          <ng-content select="thead"></ng-content>
          <thead class="text-left">
            <th *ngFor="let header of state.headers">
              <div>
                <span>{{ header.label }}</span>
                <sky-tooltip-badge *ngIf="header.tooltip" [message]="header.tooltip"></sky-tooltip-badge>
              </div>
            </th>
          </thead>
          <ng-content select="tbody"></ng-content>
        </table>
        <p class="mt-4" *ngIf="!state.model.length">Brak wyników Twojego zapytania. Wybierz inne filtry.</p>
      </ng-container>

      <sky-pagination
        *ngIf="state.pagination && filters$"
        class="pt-4 justify-end"
        [filters$]="filters$"
        [pagination]="state.pagination"
      ></sky-pagination>
    </ng-container>

    <ng-template #mobileTemplate>
      <ng-content select="[mobileTile]"></ng-content>
    </ng-template>
  `,
})
export class SkyTableComponent<T, F extends BasicFilters> {
  @Input() public state!: AsyncListState<T>;
  @Input() public filters$?: BehaviorSubject<F>;
  @Input() public isMobileView = false;
}
